<template>
  <svg
    :class="className"
    fill="none"
    :height="height"
    viewBox="0 0 15 10"
    :width="width"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M6.75235 0.841734C7.15017 0.393853 7.84983 0.393853 8.24765 0.841735L14.6822 8.08591C15.2551 8.73089 14.7972 9.75 13.9345 9.75L1.0655 9.75C0.202821 9.75 -0.255052 8.73089 0.317841 8.08591L6.75235 0.841734Z" :fill="fill"/>
  </svg>
</template>

<script>
export default {
  name: 'ScrollArrowUp',
  props: {
    width: {
      type: String,
      required: false,
      default: '15'
    },
    height: {
      type: String,
      required: false,
      default: '10'
    },
    className: {
      type: String,
      required: false,
      default: ''
    },
    fill: {
      type: String,
      required: false,
      default: '#222222'
    },
  },
};

</script>
